import { NextComponentType, NextPageContext } from 'next';
import { appWithTranslation } from 'next-i18next';
import { AppInitialProps } from 'next/app';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { useInitAuth } from '../../core/account/AuthServiceHooks';
import useStoreAffiliateParameter from '../../core/affiliate/affiliate';
import storePathValues from '../../core/hooks/storePathValues';
import analytics from '../../core/analytics/analytics';
import LanguageProvider from './LanguageProvider';
import useApplicationMaintenanceStatuses from '../../core/hooks/useApplicationMaintenanceStatuses';
import useElasticApm from '../../core/hooks/useElasticApm';

type Props = {
  Component: NextComponentType<NextPageContext, unknown, unknown>;
};

const ComponentWrapper = ({ Component, pageProps }: AppInitialProps & Props) => {
  const router = useRouter();
  useElasticApm();

  useEffect(() => storePathValues(), [router.asPath]);
  const storeParameter = useStoreAffiliateParameter();

  useEffect(
    () => {
      (async () => {
        await storeParameter();
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useInitAuth(
    useCallback(() => {
      storeParameter();
    }, [storeParameter])
  );

  useEffect(() => {
    const affiliateId = router.query.affiliate_id as string;
    if (affiliateId) {
      analytics.google.basic.track.affiliate(affiliateId);
    }
  }, [router.query.affiliate_id]);

  const applicationMaintenanceStatuses = useApplicationMaintenanceStatuses();

  return (
    <LanguageProvider>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Component {...{ ...pageProps, ...applicationMaintenanceStatuses }} />
    </LanguageProvider>
  );
};

export default appWithTranslation(ComponentWrapper);
